<template>
  <div class="additional-information-tab">
    <div
      v-for="(field, index) in fields"
      class="additional-information-tab__margin"
      :key="index"
    >
      <basic-reference-field
        :field-name="field.fieldName"
        :field-value="field.fieldValue"
      />
    </div>
  </div>
</template>

<script>
import BasicReferenceField from './BasicReferenceField';

export default {
  name: 'AdditionalInformationTab',
  components: {
    BasicReferenceField,
  },
  props: {
    winding: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    fields() {
      const { winding } = this;
      return [
        {
          fieldName: 'fields.engineering.final-gradient.alarm-temperature',
          fieldValue: winding.alarmTemperature,
        },
        {
          fieldName: 'fields.engineering.final-gradient.shutdown-temperature',
          fieldValue: winding.shutdownTemperature,
        },
      ];
    },
  },

};
</script>
<style scoped lang="sass">
  .additional-information-tab
    &__margin
      margin-right: 20px
</style>
